
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonUser} from "@/models/app/common/User";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorHealthRecordsNavigationVue from "@/components/administrator/health-records/navigation.vue";
import AppAdministratorHealthRecordsRootFilterIndexVue from "@/views/app/administrator/health-records/root/filter/index.vue";
import AppAdministratorHealthRecordsRootListIndexVue from "@/views/app/administrator/health-records/root/list/index.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorHealthRecordsNavigationVue,
    AppAdministratorHealthRecordsRootFilterIndexVue,
    AppAdministratorHealthRecordsRootListIndexVue,
  },
})
export default class AppAdministratorHealthRecordsRootIndexVue extends Vue {
  isLoading: boolean | null = false;

  players: Array<AppCommonUser> = [];

  $refs!: {
    AppAdministratorHealthRecordsRootListIndexVue: any;
  };

  getHealthRecordsByFilter(formData: any): void {
    this.$refs.AppAdministratorHealthRecordsRootListIndexVue.getHealthRecords(formData);
  }

  async getPlayers(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/organization-members`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
        role: "player",
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.players = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getPlayers();
  }
}
